import { useEffect, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";

import { QRCodeSVG } from "qrcode.react";

import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

import PrintIcon from "@mui/icons-material/Print";

export default function MaterialDetalheCabecalho({ material, ativo = true }) {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [urlImagem, setUrlImagem] = useState("");
  const [fabricanteTitulo, setFabricanteTitulo] = useState("");

  const refMaterialAtual = String(material?.refmaterial || material?.ref || "").trim();

  const nomeMaterial = String(
    material?.nomematerial || material?.nome || material?.label || ""
  ).trim();

  useEffect(() => {
    let active = true;

    const carregar = async () => {
      if (!ativo || !refMaterialAtual) {
        setUrlImagem("");
        setFabricanteTitulo("");
        return;
      }

      setLoading(true);
      setUrlImagem("");
      setFabricanteTitulo("");

      const [cabecalho, errCabecalho] = await handleApi(
        api.post("Materiais/SelCabecalhoMaterial", {
          refmaterial: refMaterialAtual,
        })
      );

      if (!active) return;

      if (errCabecalho) {
        showAlert(errCabecalho, "error");
      } else {
        const fabricante = String(cabecalho?.fabricante || "").trim();

        setFabricanteTitulo(fabricante || "Este produto não é dos nossos parceiros atuais.");
      }

      const [imagens, errImagens] = await handleApi(
        api.post("Materiais/SelMateriaisImagens", {
          refs: [refMaterialAtual],
        })
      );

      if (!active) return;

      if (!errImagens && Array.isArray(imagens) && imagens.length > 0) {
        setUrlImagem(String(imagens[0]?.url || "").trim());
      }

      setLoading(false);
    };

    carregar();

    return () => {
      active = false;
    };
  }, [ativo, refMaterialAtual, showAlert]);

  const produtoUrl = refMaterialAtual
    ? `${window.location.origin}/produto/${encodeURIComponent(refMaterialAtual)}`
    : "";

  const imprimirQrCode = () => {
    const svg = document.getElementById(`qr-produto-${refMaterialAtual}`)?.outerHTML;

    if (!svg) return;

    const janela = window.open("", "_blank", "width=400,height=500");

    if (!janela) {
      showAlert(
        "Não foi possível abrir a janela de impressão. Verifica se o browser bloqueou pop-ups.",
        "warning"
      );
      return;
    }

    janela.document.write(`
      <html>
        <head>
          <title>QR Code ${refMaterialAtual}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              text-align: center;
              padding: 24px;
            }

            .ref {
              margin-top: 12px;
              font-size: 14px;
              font-weight: bold;
            }
          </style>
        </head>

        <body>
          ${svg}
          <div class="ref">${refMaterialAtual}</div>

          <script>
            window.onload = function () {
              window.print();
            };
          </script>
        </body>
      </html>
    `);

    janela.document.close();
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        padding: "16px 20px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          minWidth: 0,
        }}
      >
        {loading ? (
          <div
            style={{
              width: 52,
              height: 52,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <CircularProgress size={22} />
          </div>
        ) : urlImagem ? (
          <img
            src={urlImagem}
            alt={nomeMaterial || refMaterialAtual}
            title="Abrir imagem"
            style={{
              width: 52,
              height: 52,
              objectFit: "contain",
              borderRadius: 8,
              border: "1px solid #eeeeee",
              backgroundColor: "#ffffff",
              cursor: "pointer",
              flexShrink: 0,
            }}
            onClick={() => window.open(urlImagem, "_blank", "noopener,noreferrer")}
          />
        ) : (
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 8,
              border: "1px solid #eeeeee",
              backgroundColor: "#fafafa",
              flexShrink: 0,
            }}
          />
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          <span
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: "#344767",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {refMaterialAtual}
            {nomeMaterial ? ` — ${nomeMaterial}` : ""}
          </span>

          {fabricanteTitulo ? (
            <span
              style={{
                marginTop: 3,
                fontSize: 12,
                color: "#7b809a",
                fontStyle: "italic",
              }}
            >
              {fabricanteTitulo}
            </span>
          ) : null}
        </div>
      </div>

      {produtoUrl ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            flexShrink: 0,
          }}
        >
          <a
            href={produtoUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir ficha pública do produto"
            style={{
              display: "inline-block",
              lineHeight: 0,
            }}
          >
            <QRCodeSVG
              id={`qr-produto-${refMaterialAtual}`}
              value={produtoUrl}
              size={72}
              level="H"
              includeMargin
              imageSettings={{
                src: "/favicon.png",
                x: undefined,
                y: undefined,
                height: 16,
                width: 16,
                excavate: true,
              }}
            />
          </a>

          <IconButton size="small" title="Imprimir QR Code" onClick={imprimirQrCode}>
            <PrintIcon fontSize="small" />
          </IconButton>
        </div>
      ) : null}
    </div>
  );
}
